(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumzo-stairs-preview"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lz-preview]').forEach((root)=>{
    const hero=root.querySelector('.lz-preview__hero-image');
    const dialog=root.querySelector('dialog');
    const enlarge=root.querySelector('[data-lz-enlarge]');
    const full=root.querySelector('[data-lz-full-photo]');
    const close=root.querySelector('[data-lz-close]');
    if(dialog&&enlarge&&full&&hero){
      enlarge.addEventListener('click',()=>{
        full.src=hero.src;
        full.alt=hero.alt;
        dialog.showModal();
        if(close)close.focus();
      });
      if(close)close.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('close',()=>enlarge.focus());
    }
    root.querySelectorAll('[data-lz-thumb]').forEach((button)=>{
      button.addEventListener('click',()=>{
        if(!hero)return;
        hero.srcset=button.dataset.srcset||'';
        hero.src=button.dataset.src;
        hero.alt=button.dataset.alt||'';
        root.querySelectorAll('[data-lz-thumb]').forEach((item)=>item.setAttribute('aria-pressed',String(item===button)));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumzo-wooden-stairs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lz-preview]').forEach((root)=>{
    const hero=root.querySelector('.lz-preview__hero-image');
    const dialog=root.querySelector('dialog');
    const enlarge=root.querySelector('[data-lz-enlarge]');
    const full=root.querySelector('[data-lz-full-photo]');
    const close=root.querySelector('[data-lz-close]');
    if(dialog&&enlarge&&full&&hero){
      enlarge.addEventListener('click',()=>{
        full.src=hero.src;
        full.alt=hero.alt;
        dialog.showModal();
        if(close)close.focus();
      });
      if(close)close.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('close',()=>enlarge.focus());
    }
    root.querySelectorAll('[data-lz-thumb]').forEach((button)=>{
      button.addEventListener('click',()=>{
        if(!hero)return;
        hero.srcset=button.dataset.srcset||'';
        hero.src=button.dataset.src;
        hero.alt=button.dataset.alt||'';
        root.querySelectorAll('[data-lz-thumb]').forEach((item)=>item.setAttribute('aria-pressed',String(item===button)));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumzo-xl-plush-bed"] && !Shopify.designMode) return;
  try {
    

  document.querySelectorAll('[data-lz-bed]').forEach((root)=>{
    const hero=root.querySelector('.lz-bed__hero-image');
    const dialog=root.querySelector('dialog');
    const enlarge=root.querySelector('[data-lz-enlarge]');
    const full=root.querySelector('[data-lz-full-photo]');
    const close=root.querySelector('[data-lz-close]');
    if(dialog&&enlarge&&full&&hero){
      enlarge.addEventListener('click',()=>{
        full.src=hero.src;
        full.alt=hero.alt;
        dialog.showModal();
        if(close)close.focus();
      });
      if(close)close.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('keydown',(event)=>{
        if(event.key!=='Tab'||!dialog.open||event.defaultPrevented)return;
        const items=Array.from(dialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter((item)=>!item.disabled&&item.tabIndex>=0&&!item.closest('[hidden],[inert]')&&item.getClientRects().length);
        const first=items[0];
        const last=items[items.length-1];
        const active=document.activeElement;
        if(!first){
          event.preventDefault();
          dialog.focus();
        }else if(items.length===1||!dialog.contains(active)||(event.shiftKey&&active===first)||(!event.shiftKey&&active===last)){
          event.preventDefault();
          (event.shiftKey?last:first).focus();
        }
      });
      dialog.addEventListener('close',()=>enlarge.focus());
    }
    root.querySelectorAll('[data-lz-thumb]').forEach((button)=>{
      button.addEventListener('click',()=>{
        if(!hero)return;
        hero.srcset=button.dataset.srcset||'';
        hero.src=button.dataset.src;
        hero.alt=button.dataset.alt||'';
        root.querySelectorAll('[data-lz-thumb]').forEach((item)=>item.setAttribute('aria-pressed',String(item===button)));
      });
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
